import { render, staticRenderFns } from "./UserContract.vue?vue&type=template&id=088c70dc&"
import script from "./UserContract.vue?vue&type=script&lang=js&"
export * from "./UserContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports